export default "__VITE_ASSET__BmS_wlWe__"